import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_settings_list_element = _resolveComponent("settings-list-element")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputItems, (element, index) => {
    return (_openBlock(), _createBlock(_component_settings_list_element, {
      style: {"margin-left":"23px !important","display":"flex !important"},
      element: element,
      key: (element as ColumnListItem).compound_id,
      "input-index": index,
      "parent-id": undefined,
      "parent-name": '',
      "parent-idx": (element as ColumnListItem).compound_id,
      "is-root": true,
      onChangeSelection: _ctx.onModelUpdate
    }, null, 8, ["element", "input-index", "parent-idx", "onChangeSelection"]))
  }), 128))
}